import _uniqueId from 'lodash/uniqueId';
import { useRef } from 'react';

export const useUniqueId = (prefix = '') => {
	const id = useRef(_uniqueId(prefix));
	return id.current;
};
